import React,{useState,useEffect} from 'react'
import axios from 'axios'
import {showLoading } from 'react-global-loading';
import { API_URL } from '../../../Constant';
import { ToastContainer, toast } from 'react-toastify';
import messages from '../../../assets/Messages.json';
import { useNavigate } from 'react-router-dom';
import {generateYearRange,isNumeric, validateButtonASIBlock,getStatusFlagValue} from '../../../Custom/Custom';
import titlesData from '../../../titles.json';
import asiTitle from '../../../asi.json';

export default function BlockC({
  blockPageInfo,
  config,
  userInfoObject,
  blockInfo,
  accessAsiBlock,
  decode_token
}) {

  
  const [itemData, setItemData] = useState({});
  const [blockCData, setBlockCData] = useState([]);
  const navigate = useNavigate();
  // Static values for display
  const staticDslNo = 304107;
  const staticSurveyYear = 2024;
  const yearRange=generateYearRange(staticSurveyYear);
  const [buttonStatus,setButtonStatus]=useState('');
  let srNo=0;
  let statusAlertC=0;
  let allValidactionAlertBlockC='';
  let flagC = 0;
  const statusUnitCode=localStorage.getItem('statusUnitCode')
  const storedLanguage = localStorage.getItem('language');

  // Static Types of Assets data
  const staticBlockCData = [
    { assetCode: 1, ItemName: 'Land (excluding land improvement)' },
    { assetCode: 2, ItemName: 'Land improvement' },
    { assetCode: 3, ItemName: 'Building & other structures' },
    { assetCode: 4, ItemName: 'Plant & Machinery' },
    { assetCode: 5, ItemName: 'Transport equipment' },
    { assetCode: 6, ItemName: 'Pollution control equipment/ Environment improvement equipment' },
    { assetCode: 7, ItemName: 'Information, computer & Telecommunication equipment' },
    { assetCode: 8, ItemName: 'Software & database' },
    { assetCode: 9, ItemName: 'R&D and other intellectual property products' },
    { assetCode: 10, ItemName: 'Others' },
    { assetCode: 11, ItemName: 'Sub-total (items 2 to 10)' },
    { assetCode: 12, ItemName: 'Capital work in progress' },
    { assetCode: 13, ItemName: 'Total (items 1+11+12)' },
    { assetCode: 14, ItemName: 'Non-produced intangible assets' }
  ];

  // Function to get authentication config with token
  const getAuthConfig = () => {
    // Try multiple possible token keys
    let token = localStorage.getItem('jwt') || 
                localStorage.getItem('token') || 
                localStorage.getItem('authToken') || 
                localStorage.getItem('accessToken') ||
                localStorage.getItem('userToken');
    
    if (!token) {
      // Try to get from sessionStorage as well
      token = sessionStorage.getItem('token') ||
              sessionStorage.getItem('jwt') ||
              sessionStorage.getItem('accessToken');
    }
    
    if (!token) {
      console.error('No authentication token found');
      toast.error('Authentication token not found. Please login again.', messages.COLOR_RED);
      return {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      };
    }
    
    // Clean the token (remove any extra spaces or quotes)
    const cleanToken = token.replace(/['"]/g, '').trim();
    
    return {
      headers: {
        'Authorization': `Bearer ${cleanToken}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    };
  };

  useEffect(()=>{

    // Function to handle page load Form data
     const blockBData= async()=>{
     
     // Static payload
     const newObject={
        dsl_no: 304107,
        survey_year: 2024
      };
      
      // COMMENTED OUT: Dynamic API call - using static data instead
      // showLoading(true)
      // try {
      //   const authConfig = getAuthConfig();
      //   const response = await axios.post(`${API_URL}api/asi/blockCForm`, newObject, authConfig);
      //   const {data,status} = response.data;
      //      if (status) {
      //         const blockCData=data.blockCData;
      //         setBlockCData(blockCData)
      //          const statusFlage = blockCData[0].statusFlag;
      //          const buttonStatus = await validateButtonASIBlock(decode_token, statusFlage);
      //          setButtonStatus(buttonStatus);

      //         const initialData = {};
    
      //         blockCData.forEach(item => {
      //              // Convert assetCode to string for consistent key access
      //              const assetCodeKey = String(item.assetCode);
      //              initialData[assetCodeKey] = {
      //               dslNo: item.dslNo || '',
      //               surveyYear: item.surveyYear || '',
      //               assetCode: item.assetCode,
      //               // Map all fields from API response - handle empty strings and null values
      //               dueToRevaluation: (item.dueToRevaluation !== null && item.dueToRevaluation !== undefined && item.dueToRevaluation !== '') ? String(item.dueToRevaluation) : '',
      //               actualAdditions: (item.actualAdditions !== null && item.actualAdditions !== undefined && item.actualAdditions !== '') ? String(item.actualAdditions) : '',
      //               deductionAdjDuringYear: (item.deductionAdjDuringYear !== null && item.deductionAdjDuringYear !== undefined && item.deductionAdjDuringYear !== '') ? String(item.deductionAdjDuringYear) : '',
      //               closingAsOn3456: (item.closingAsOn3456 !== null && item.closingAsOn3456 !== undefined && item.closingAsOn3456 !== '') ? String(item.closingAsOn3456) : '',
      //               uptoYearBeginning: (item.uptoYearBeginning !== null && item.uptoYearBeginning !== undefined && item.uptoYearBeginning !== '') ? String(item.uptoYearBeginning) : '',
      //               providedDuringYear: (item.providedDuringYear !== null && item.providedDuringYear !== undefined && item.providedDuringYear !== '') ? String(item.providedDuringYear) : '',
      //               adjForSoldDiscardedDuringYear: (item.adjForSoldDiscardedDuringYear !== null && item.adjForSoldDiscardedDuringYear !== undefined && item.adjForSoldDiscardedDuringYear !== '') ? String(item.adjForSoldDiscardedDuringYear) : '',
      //               uptoYearEnd: (item.uptoYearEnd !== null && item.uptoYearEnd !== undefined && item.uptoYearEnd !== '') ? String(item.uptoYearEnd) : '',
      //               openingAsOn38: (item.openingAsOn38 !== null && item.openingAsOn38 !== undefined && item.openingAsOn38 !== '') ? String(item.openingAsOn38) : '',
      //               openingAsOn: (item.openingAsOn !== null && item.openingAsOn !== undefined && item.openingAsOn !== '') ? String(item.openingAsOn) : '',
      //               closingAsOn711: (item.closingAsOn711 !== null && item.closingAsOn711 !== undefined && item.closingAsOn711 !== '') ? String(item.closingAsOn711) : '',
      //               statusFlag: item.statusFlag || '',
      //               // Initialize all class properties
      //               closingAsOn3456Class:'textBox_back_color_white',
      //               uptoYearEndClass:'textBox_back_color_white',
      //               openingAsOn38Class:'textBox_back_color_white',
      //               closingAsOn711Class:'textBox_back_color_white',
      //               providedDuringYearClass: 'textBox_back_color_white',
      //               openingAsOnClass:'textBox_back_color_white',
      //               dueToRevaluationClass:'textBox_back_color_white',
      //               actualAdditionsClass:'textBox_back_color_white',
      //               deductionAdjDuringYearClass:'textBox_back_color_white',
      //               adjForSoldDiscardedDuringYearClass:'textBox_back_color_white',
      //               uptoYearBeginningClass:'textBox_back_color_white'

      //              };
      //            });
              
      //        setItemData(initialData);
      //     }
      // } catch (error) {
      //     console.error(error);
      //     toast.error('An error occurred while processing your request.', messages.COLOR_RED);
      // } finally {
      //     showLoading(false);
      // }

      // Using static data instead
      setBlockCData(staticBlockCData);
      
      // Initialize itemData for static assets
      const initialData = {};
      staticBlockCData.forEach(item => {
        const assetCodeKey = String(item.assetCode);
        initialData[assetCodeKey] = {
          dslNo: staticDslNo,
          surveyYear: staticSurveyYear,
          assetCode: item.assetCode,
          dueToRevaluation: '',
          actualAdditions: '',
          deductionAdjDuringYear: '',
          closingAsOn3456: '',
          uptoYearBeginning: '',
          providedDuringYear: '',
          adjForSoldDiscardedDuringYear: '',
          uptoYearEnd: '',
          openingAsOn38: '',
          openingAsOn: '',
          closingAsOn711: '',
          statusFlag: '',
          closingAsOn3456Class:'textBox_back_color_white',
          uptoYearEndClass:'textBox_back_color_white',
          openingAsOn38Class:'textBox_back_color_white',
          closingAsOn711Class:'textBox_back_color_white',
          providedDuringYearClass: 'textBox_back_color_white',
          openingAsOnClass:'textBox_back_color_white',
          dueToRevaluationClass:'textBox_back_color_white',
          actualAdditionsClass:'textBox_back_color_white',
          deductionAdjDuringYearClass:'textBox_back_color_white',
          adjForSoldDiscardedDuringYearClass:'textBox_back_color_white',
          uptoYearBeginningClass:'textBox_back_color_white'
        };
      });
      setItemData(initialData);
  
    }
    blockBData();
  
    },[])



  // Function to handle going to the next block  
  const handleNext= async()=>{
    const confirmed = window.confirm("Have you saved your changes?");
   if (confirmed) {
      if(statusUnitCode==='5'){
            const saveResult = await handleSaveData("SAVE");
            if(saveResult){
               blockValidation()
               navigate("/BlockD")
            }
     
      }else{
         const saveResult = await handleSaveData("SAVE");
         if (saveResult) {
            blockValidation()
            navigate("/BlockD")
        }
      }
   }
}



  //All block validation Data
  const  blockValidation=async()=>{

   if (!blockInfo || !blockInfo.dslNo || !blockInfo.surveyYear) {
     console.log('BlockInfo is missing for validation');
     return false;
   }

   let  postData= {
      dsl_no: blockInfo.dslNo,
      survey_year: blockInfo.surveyYear
     }
 
      try {
       showLoading(true);
       const authConfig = getAuthConfig();
       const response = await axios.post(`${API_URL}api/asi/blockValidation`, postData, authConfig);
      const {data,status} = response.data;
      const accessIds=data.allblockData
       if(accessIds.length>0){

         if(accessIds.length > [1,2,3,4].length){
            accessAsiBlock(accessIds)
          }else{
            accessAsiBlock([1,2,3,4])
          }

       }else{
          accessAsiBlock([1,2,3,4])
       }
       showLoading(false);
        return true;
 
      } catch (error) {
         console.error(error);
         toast.error('An error occurred while processing your request.', messages.COLOR_RED);
     } finally {
     
    }
 
 }




// Function to handle going to the previous block
const handlePrevious=()=>{
 const confirmed = window.confirm("Have you saved your changes?");
 if (confirmed) {
   // handleSaveData("SAVE")
   navigate("/BlockB")
 }
 
}


// Function to handle reset Form Data
const handleReset=()=>{
  if (!blockCData || !Array.isArray(blockCData) || blockCData.length === 0) {
    return;
  }
  const initialData = {};
  blockCData.forEach(item => {
	   initialData[item.assetCode] = {
     dslNo: item.dslNo,
     surveyYear: item.surveyYear,
     assetCode: item.assetCode,
     statusFlag:item.statusFlag,
	  controlled_price: '',
     dueToRevaluation: '',
     actualAdditions: '',
     deductionAdjDuringYear: '',
     closingAsOn3456: '',
     uptoYearBeginning: '',
     providedDuringYear: '',
     adjForSoldDiscardedDuringYear: '',
     uptoYearEnd: '',
     openingAsOn38:'',
     openingAsOn: '',
     closingAsOn711: '',
     closingAsOn3456Class:'textBox_back_color_white',
     uptoYearEndClass:'textBox_back_color_white',
     openingAsOn38Class:'textBox_back_color_white',
     closingAsOn711Class:'textBox_back_color_white',
     providedDuringYearClass:'textBox_back_color_white',
     openingAsOnClass:'textBox_back_color_white',
     dueToRevaluationClass:'textBox_back_color_white',
     actualAdditionsClass:'textBox_back_color_white',
     deductionAdjDuringYearClass:'textBox_back_color_white',
     adjForSoldDiscardedDuringYearClass:'textBox_back_color_white',
     uptoYearBeginningClass:'textBox_back_color_white'
   };
	 });
  
 setItemData(initialData);
}



  // Function to handle State on change
const handleOnChange = (assetCode, field, newValue) => {
    // Convert assetCode to string for consistent key access
    const assetCodeKey = String(assetCode);
    
    // Allow negative values for specific fields
    const allowNegativeFields = [
      'closingAsOn3456', // column 7
      'uptoYearEnd',     // column 11
      'openingAsOn38',   // column 12
      'closingAsOn711'   // column 13
    ];

    // Custom numeric validation: allow negative for specific fields
    const isAllowedField = allowNegativeFields.includes(field);
    const isValid = isAllowedField
      ? /^-?\d*(\.\d*)?$/.test(newValue) // allow negative and decimal
      : isNumeric(newValue);

    if (!isValid && newValue !== "") {
      toast.error(messages.NUMERIC_MSG, messages.COLOR_RED);
      newValue = '';
    }

    setItemData(prevItemData => {
      const updatedItemData = {
        ...prevItemData,
        [assetCodeKey]: {
          ...prevItemData[assetCodeKey],
          [field]: newValue
        }
      };

      return updatedItemData;
    });
}


// Function to handle update and save form data
const handleSaveData = async(buttonType) => {
   if (statusUnitCode !== '5' && !valForBlockC()) {
      return false;
  };
   //return false;   
    let customItemCodes=[];
    const clickButtonStatusFlag = getStatusFlagValue(buttonType, userInfoObject.userLevel);
    for (let assetCode in itemData) {
      const customObject = {
         dslNo: itemData[assetCode].dslNo,
         surveyYear: itemData[assetCode].surveyYear,
         assetCode: itemData[assetCode].assetCode,
         openingAsOn: handleValue(itemData[assetCode].openingAsOn),
         dueToRevaluation: handleValue(itemData[assetCode].dueToRevaluation),
         actualAdditions: handleValue(itemData[assetCode].actualAdditions),
         deductionAdjDuringYear: handleValue(itemData[assetCode].deductionAdjDuringYear),
         closingAsOn3456: handleValue(itemData[assetCode].closingAsOn3456),
         uptoYearBeginning: handleValue(itemData[assetCode].uptoYearBeginning),
         providedDuringYear: handleValue(itemData[assetCode].providedDuringYear),
         adjForSoldDiscardedDuringYear: handleValue(itemData[assetCode].adjForSoldDiscardedDuringYear),
         uptoYearEnd: handleValue(itemData[assetCode].uptoYearEnd),
         openingAsOn38: handleValue(itemData[assetCode].openingAsOn38),
         closingAsOn711: handleValue(itemData[assetCode].closingAsOn711),
         statusFlag:clickButtonStatusFlag
    
         
      };

      customItemCodes.push(customObject); 
    }
   
   
     if (!blockInfo || !blockInfo.dslNo || !blockInfo.surveyYear) {
       toast.error('Block information is missing. Please go back and select DSL No. and Survey Year.', messages.COLOR_RED);
       showLoading(false);
       return false;
     }

     const newObject={
          itemCodes:customItemCodes,
          payload:{
             dsl_no: blockInfo.dslNo,
             survey_year:  blockInfo.surveyYear,
             buttonType:buttonType
          }
        }
        showLoading(true);
       
         try {
          const authConfig = getAuthConfig();
          const response = await axios.post(`${API_URL}api/asi/blockCFormSaveToDB`, newObject, authConfig);
         const {status,message} = response.data;
         if (status) {
            blockValidation();
           toast.success(message, messages.COLOR_RED);
           return true;
         }
       } catch (error) {
           console.error(error);
           toast.error('An error occurred while processing your request.', messages.COLOR_RED);
       } finally {
           showLoading(false);
       }
      return false;
   }


   // Function to handle if value empty or null or undefined the set 0
 const handleValue = (value) => {
      return (value !== "" && value !== null && value !== undefined) ? value : 0;
    };
    

   // Function to handle set (Update State) form validation and calculation 
   const handleValidationAlert = (blockCData) => { 
      const initialData = {};
      blockCData.forEach(item => {
           initialData[item.assetCode] = {
            dslNo: item.dslNo,
            surveyYear: item.surveyYear,
            assetCode: item.assetCode,
            dueToRevaluation: item.dueToRevaluation,
            actualAdditions: item.actualAdditions,
            deductionAdjDuringYear: item.deductionAdjDuringYear,
            closingAsOn3456: item.closingAsOn3456,
            uptoYearBeginning: item.uptoYearBeginning,
            providedDuringYear: item.providedDuringYear,
            adjForSoldDiscardedDuringYear: item.adjForSoldDiscardedDuringYear,
            uptoYearEnd: item.uptoYearEnd,
            openingAsOn38:item.openingAsOn38,
            openingAsOn: item.openingAsOn,
            closingAsOn711: item.closingAsOn711,
            statusFlag:item.statusFlag,
            closingAsOn3456Class:item.closingAsOn3456Class,
            uptoYearEndClass:item.uptoYearEndClass,
            openingAsOn38Class:item.openingAsOn38Class,
            closingAsOn711Class:item.closingAsOn711Class,
            providedDuringYearClass:item.providedDuringYearClass,
            openingAsOnClass:item.openingAsOnClass,
            dueToRevaluationClass:item.dueToRevaluationClass,
            actualAdditionsClass:item.actualAdditionsClass,
            deductionAdjDuringYearClass:item.deductionAdjDuringYearClass,
            adjForSoldDiscardedDuringYearClass:item.adjForSoldDiscardedDuringYearClass,
            uptoYearBeginningClass:item.uptoYearBeginningClass
           };
         });
      
     setItemData(initialData);
   }
   
// Function to handle calculation 
const valForBlockC=()=>{

   const yearArray = [2017,2018,2019,2020,2021];
   const customItemCodes = [];
   const openingAsOnObject=[];
   const dueToRevaluationObject=[];
   const actualAdditionsObject=[];
   const deductionAdjDuringYearObject=[];
   const uptoYearBeginningObject=[];
   const providedDuringYearObject=[];
   const adjForSoldDiscardedDuringYearObject=[];
   
      for (let assetCodeId in itemData) {


             let openingAsOn = itemData[assetCodeId].openingAsOn;
             let dueToRevaluation = itemData[assetCodeId].dueToRevaluation;
             let actualAdditions = itemData[assetCodeId].actualAdditions;
             let deductionAdjDuringYear = itemData[assetCodeId].deductionAdjDuringYear;

             let closingAsOn3456 = itemData[assetCodeId].closingAsOn3456;
             let uptoYearBeginning = itemData[assetCodeId].uptoYearBeginning;
             let providedDuringYear = itemData[assetCodeId].providedDuringYear;

             let adjForSoldDiscardedDuringYear = itemData[assetCodeId].adjForSoldDiscardedDuringYear;
             let uptoYearEnd = itemData[assetCodeId].uptoYearEnd;
             let openingAsOn38 = itemData[assetCodeId].openingAsOn38;
             let closingAsOn711 = itemData[assetCodeId].closingAsOn711;
          

             let dslNo = itemData[assetCodeId].dslNo;
             let surveyYear = itemData[assetCodeId].surveyYear;
             let statusFlag = itemData[assetCodeId].statusFlag;
             let assetCode = itemData[assetCodeId].assetCode



            //   class
             let closingAsOn3456Class = itemData[assetCodeId].closingAsOn3456Class;
             let uptoYearEndClass = itemData[assetCodeId].uptoYearEndClass;
             let openingAsOn38Class = itemData[assetCodeId].openingAsOn38Class;
             let closingAsOn711Class = itemData[assetCodeId].closingAsOn711Class;
             let providedDuringYearClass = itemData[assetCodeId].providedDuringYearClass
             let openingAsOnClass = itemData[assetCodeId].openingAsOnClass
             
            if (openingAsOn === '' || openingAsOn === 'null') {
               openingAsOn = 0;
           }
           if (dueToRevaluation === '' || dueToRevaluation === 'null') {
               dueToRevaluation = 0;
           }
          if (actualAdditions === '' || actualAdditions === 'null') {
             actualAdditions = 0;
          }
          if (deductionAdjDuringYear === '' || deductionAdjDuringYear === 'null') {
             deductionAdjDuringYear = 0;
          }
    
    
          if (closingAsOn3456 === '' || closingAsOn3456 === 'null') {
             closingAsOn3456 = 0;
          }
          if (uptoYearBeginning === '' || uptoYearBeginning === 'null') {
             uptoYearBeginning = 0;
          }
          if (providedDuringYear === '' || providedDuringYear === 'null') {
             providedDuringYear = 0;
          }
    
    
          if (adjForSoldDiscardedDuringYear === '' || adjForSoldDiscardedDuringYear === 'null') {
             adjForSoldDiscardedDuringYear = 0;
          }
          if (uptoYearEnd === '' || uptoYearEnd === 'null') {
             uptoYearEnd = 0;
          }
          if (openingAsOn38 === '' || openingAsOn38 === 'null') {
             openingAsOn38 = 0;
          }
          if (closingAsOn711 === '' || closingAsOn711 === 'null') {
             closingAsOn711 = 0;
          }

           //************************************************** */
         if(yearArray.includes(blockInfo.surveyYear)){
            

            // #1  (3 || 4 || 5 || 6)
            if(openingAsOn !== null || dueToRevaluation !== null || 
               actualAdditions !== null || deductionAdjDuringYear !== null){
                  const a3 = parseFloat(openingAsOn); //3
                  const b4 = parseFloat(dueToRevaluation); //4
                  const c5 = parseFloat(actualAdditions); //5
                  const d6 = parseFloat(deductionAdjDuringYear); //6
                  const e7 = parseFloat(closingAsOn3456); //7
                  const f345_6 = a3 + b4 + c5 - d6; 
                  if (e7 !== f345_6) {
                     closingAsOn3456Class="textBox_back_color_red";
                      flagC = 1;
                  } else {
                     closingAsOn3456Class="textBox_back_color_white";
                  }

               }

            // #2  ( 8 || 9 || 10)
               if(uptoYearBeginning !== null || providedDuringYear !== null || 
                  adjForSoldDiscardedDuringYear !== null ){
                  

                     const a5 = parseFloat(actualAdditions);//5
                     const b8 = parseFloat(uptoYearBeginning);//8
                     const c9 = parseFloat(providedDuringYear);//9
                     const d10 = parseFloat(adjForSoldDiscardedDuringYear);//10
                     const e11 = parseFloat(uptoYearEnd);//11
                     const f12 = parseFloat(openingAsOn38);//12
                     const g512 = a5 + f12;  //5+12
                     
                     if (c9 <= (40 * parseFloat(g512)) / 100) {
                        providedDuringYearClass="textBox_back_color_white";

                  } else {
                        providedDuringYearClass="textBox_back_color_orange";
                           if(allValidactionAlertBlockC.indexOf("Col. 9 < =  40% of (col. 5 + col. 12)")<0){
                              allValidactionAlertBlockC = allValidactionAlertBlockC + " Col. 9 < =  40% of (col. 5 + col. 12). \n";
                           }  
                           statusAlertC=1;                                      
                     }

                  
                     const h89_10 = b8 + c9 - d10; //8+9-10
                     if (e11 !== h89_10) {
                        uptoYearEndClass="textBox_back_color_red";
                        flagC = 1;
                  } else {
                     uptoYearEndClass="textBox_back_color_white";
                  }


               }

            //#3 (3 || 8)
               if(openingAsOn !== null || uptoYearBeginning !== null){
                  const a3 = parseFloat(openingAsOn); //3
                  const b8 = parseFloat(uptoYearBeginning);//8
                  const c12 = parseFloat(openingAsOn38);//12
                  const d13 = parseFloat(closingAsOn711);//13
                  const e3_8 = a3 - b8; //3-8
               if (c12 !== e3_8) {
                     openingAsOn38Class="textBox_back_color_red";
                     flagC = 1;

               } else {
               
                     if (c12 > 0 && d13 > 0)
                     {
                        const f1213 = parseFloat(c12 / d13);
                        if (0.2 <= parseFloat(f1213) && parseFloat(f1213) <= 5) {
                              openingAsOn38Class="textBox_back_color_white";

                        } else {
                              openingAsOn38Class = 'textBox_back_color_orange';
                           if(allValidactionAlertBlockC.indexOf("0.2 <= (col.12/col.13) <= 5")<0){
                                 allValidactionAlertBlockC = allValidactionAlertBlockC + " 0.2 <= (col.12/col.13) <= 5, if both col.12 and col.13> 0. \n";
                           }
                           statusAlertC = 1;
                        }
                     }

               }

               }
               
            //#4 (7 || 11)
               if(closingAsOn3456 !==null || uptoYearEnd !==null ){

                  const a7 = parseFloat(closingAsOn3456); //7
                  const b11 = parseFloat(uptoYearEnd);//11
                  const c12 = parseFloat(openingAsOn38);//12
                  const d13 = parseFloat(closingAsOn711);//13
                  const e7_11 = a7 - b11;

                  if (d13 !== e7_11) {
                        closingAsOn711Class="textBox_back_color_red"
                        flagC = 1;

               } else {
                     
                     if (c12 > 0 && d13 > 0)
                     {
                        const f1213 = parseFloat(c12) / parseFloat(d13);
                        if (0.2 <= parseFloat(f1213) && parseFloat(f1213) <= 5) {
                           closingAsOn711Class = "textBox_back_color_white"
                        } else {

                           closingAsOn711Class = "textBox_back_color_orange";

                        }
                     }


               }
               }

        }else{

           //#1  (3 || 4 || 5 || 6)
           if(openingAsOn !== null && dueToRevaluation !== null
             && actualAdditions !== null && deductionAdjDuringYear !== null){

               const a3_3456 = parseFloat(openingAsOn); //3
               const b4_3456 = parseFloat(dueToRevaluation);//4
               const c5_3456 = parseFloat(actualAdditions);//5
               const d6_3456 = parseFloat(deductionAdjDuringYear);//6
               const e7_3456 = parseFloat(closingAsOn3456); //7
               const f345_6_3456 = a3_3456 + b4_3456 + c5_3456 - d6_3456; 

               if (e7_3456 !== f345_6_3456) { //(7) != (3+4+5-6)
                  closingAsOn3456Class="textBox_back_color_red";
               	flagC=1;
                } else {
                  closingAsOn3456Class="textBox_back_color_white";
               }

             }

            //#2 (8 || 9 || 10)
            if(uptoYearBeginning !== null && providedDuringYear !== null && 
               adjForSoldDiscardedDuringYear !== null)
            {
               const a8_8910 = parseFloat(uptoYearBeginning);//8
               const b9_8910 = parseFloat(providedDuringYear);//9
               const c10_8910 = parseFloat(adjForSoldDiscardedDuringYear);//10
               const d11_8910 = parseFloat(uptoYearEnd); //11
               const f89_10 = a8_8910 + b9_8910 - c10_8910;
               if (d11_8910 !== f89_10) {  //(11) !==(8+9-10)
                  uptoYearEndClass="textBox_back_color_red";
                  flagC=1;
               } else {
                  uptoYearEndClass="textBox_back_color_white";
               }
            }
       
            //#3  (3 || 8)
            if(openingAsOn !== null || uptoYearBeginning !== null){
               const a3_38 = parseFloat(openingAsOn); //3
               const b8_38 = parseFloat(uptoYearBeginning);//8
               const c12_38 = parseFloat(openingAsOn38);//12
               const d3_8 = a3_38 - b8_38;
               if(c12_38 !== d3_8 ){    //(12) !== (3-4) 
                  openingAsOn38Class="textBox_back_color_red";
                  flagC=1;
               }else{
                  openingAsOn38Class="textBox_back_color_white";
               }
            }

             //#4 (7 || 11)
             if(closingAsOn3456 !== null || uptoYearEnd !== null){

               const a3_7_11 = parseFloat(openingAsOn); //3
               const b4_7_11 = parseFloat(dueToRevaluation);//4
               const c5_7_11 = parseFloat(actualAdditions);//5
               const d6_7_11 = parseFloat(deductionAdjDuringYear);//6

               const a8_7_11 = parseFloat(uptoYearBeginning);//8
               const b9_7_11 = parseFloat(providedDuringYear);//9
               const c10_7_11 = parseFloat(adjForSoldDiscardedDuringYear);//10



               // const a7 = parseFloat(closingAsOn3456); //7
               // const b11 = parseFloat(uptoYearEnd);//11
               const c13 = parseFloat(closingAsOn711);//13
               //var d7_11 = a7-b11;
               const f3456_7_11 = a3_7_11 + b4_7_11 + c5_7_11 - d6_7_11;  //val7
               const f8910_7_11 = a8_7_11 + b9_7_11 - c10_7_11; //val11
               const d7_11 = f3456_7_11 - f8910_7_11;

            if(c13 !== d7_11){ 
                  closingAsOn711Class="textBox_back_color_red";
                  flagC=1;
               }else{
                  closingAsOn711Class="textBox_back_color_white";
               }
             }
       }
      const customObject = {
               assetCode: assetCode,
               openingAsOn:openingAsOn,
               dueToRevaluation:dueToRevaluation,
               actualAdditions:actualAdditions,
               deductionAdjDuringYear:deductionAdjDuringYear,
               closingAsOn3456:closingAsOn3456,
               uptoYearBeginning:uptoYearBeginning,
               providedDuringYear:providedDuringYear,
               adjForSoldDiscardedDuringYear:adjForSoldDiscardedDuringYear,
               uptoYearEnd:uptoYearEnd,
               openingAsOn38:openingAsOn38,
               closingAsOn711:closingAsOn711,
               dslNo:dslNo,
               surveyYear:surveyYear,
               statusFlag:statusFlag,
               closingAsOn3456Class:closingAsOn3456Class,
               uptoYearEndClass:uptoYearEndClass,
               openingAsOn38Class:openingAsOn38Class,
               closingAsOn711Class:closingAsOn711Class,
               providedDuringYearClass:providedDuringYearClass,
               openingAsOnClass:openingAsOnClass
               
           };
           openingAsOnObject.push(parseFloat(openingAsOn))
           dueToRevaluationObject.push(parseFloat(dueToRevaluation))
           actualAdditionsObject.push(parseFloat(actualAdditions))
           deductionAdjDuringYearObject.push(parseFloat(deductionAdjDuringYear))
           uptoYearBeginningObject.push(parseFloat(uptoYearBeginning))
           providedDuringYearObject.push(parseFloat(providedDuringYear))
           adjForSoldDiscardedDuringYearObject.push(parseFloat(adjForSoldDiscardedDuringYear))
           customItemCodes.push(customObject);

      }
      const allRowsObject={
         openingAsOnObject:openingAsOnObject,
         dueToRevaluationObject:dueToRevaluationObject,
         actualAdditionsObject:actualAdditionsObject,
         deductionAdjDuringYearObject:deductionAdjDuringYearObject,
         uptoYearBeginningObject:uptoYearBeginningObject,
         providedDuringYearObject:providedDuringYearObject,
         adjForSoldDiscardedDuringYearObject:adjForSoldDiscardedDuringYearObject,
         customItemCodes:customItemCodes
      }
   return valueInsertedA1(allRowsObject); 
}

const  valueInsertedA1=(allRowsObject)=>{
  
   const openingAsOnObject=allRowsObject.openingAsOnObject
   const openingAsOn6 = openingAsOnObject[7]
   const numbers = openingAsOnObject.slice(1, 7).map(item => parseFloat(item)).filter(item => !isNaN(item));
   const openingAsOn1To6 = numbers.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
   if(openingAsOn6!== openingAsOn1To6){
      flagC = 1;
      allRowsObject.customItemCodes[7].openingAsOnClass="textBox_back_color_red";

      // openingAsOn7 make red
   }else{
      allRowsObject.customItemCodes[7].openingAsOnClass="textBox_back_color_white";
      // openingAsOn7 make while
   }
 
   return valueInsertedB1(allRowsObject);
}

const valueInsertedB1=(allRowsObject)=>{
   const openingAsOnObject=allRowsObject.openingAsOnObject;
   const openingAsOn0 = openingAsOnObject[0];
   const openingAsOn7 = openingAsOnObject[7];
   const openingAsOn8 = openingAsOnObject[8];
   const openingAsOn9test = openingAsOnObject[9];

   // Corrected: Row 10 = Row 1 + Row 8 + Row 9 (index 0 + 7 + 8)
   const openingAsOn10ShouldBe = openingAsOn0 + openingAsOn7 + openingAsOn8;

   if(openingAsOn9test !== openingAsOn10ShouldBe){
      flagC=1;
      allRowsObject.customItemCodes[9].openingAsOnClass="textBox_back_color_red";
   } else {
      allRowsObject.customItemCodes[9].openingAsOnClass="textBox_back_color_white";
   }

   return valueInsertedA2(allRowsObject);
}

const valueInsertedA2=(allRowsObject)=>{
   const dueToRevaluationRow=allRowsObject.dueToRevaluationObject;
   const dueToRevaluation1 = dueToRevaluationRow[1];
   const dueToRevaluation2 = dueToRevaluationRow[2];
   const dueToRevaluation3 = dueToRevaluationRow[3];
   const dueToRevaluation4 = dueToRevaluationRow[4];
   const dueToRevaluation5 = dueToRevaluationRow[5];
   const dueToRevaluation6 = dueToRevaluationRow[6];
   const dueToRevaluation7test = dueToRevaluationRow[7];

   const dueToRevaluation1to6 = (dueToRevaluation1 + dueToRevaluation2 + dueToRevaluation3 + dueToRevaluation4 + dueToRevaluation5 + dueToRevaluation6);
   if(dueToRevaluation7test !== dueToRevaluation1to6){
      flagC=1;
      // let a="add red class"
      // dueToRevaluation7 make red
      allRowsObject.customItemCodes[7].dueToRevaluationClass="textBox_back_color_red";
   } else {
      // let b= "add white class"
      // dueToRevaluation7 make while
      allRowsObject.customItemCodes[7].dueToRevaluationClass="textBox_back_color_white";
   }
   return valueInsertedB2(allRowsObject);
}

const valueInsertedB2=(allRowsObject)=>{
   const dueToRevaluationRow=allRowsObject.dueToRevaluationObject;
   const dueToRevaluation0 = dueToRevaluationRow[0];
   const dueToRevaluation8 = dueToRevaluationRow[8];
   const dueToRevaluation9Test = dueToRevaluationRow[9];

   const dueToRevaluation1 = dueToRevaluationRow[1];
   const dueToRevaluation2 = dueToRevaluationRow[2];
   const dueToRevaluation3 = dueToRevaluationRow[3];
   const dueToRevaluation4 = dueToRevaluationRow[4];
   const dueToRevaluation5 = dueToRevaluationRow[5];
   const dueToRevaluation6 = dueToRevaluationRow[6];

   const sum1to6 = dueToRevaluation1 + dueToRevaluation2 + dueToRevaluation3 + dueToRevaluation4 + dueToRevaluation5 + dueToRevaluation6;
   const dueToRevaluation9ShouldBe = dueToRevaluation0 + sum1to6 + dueToRevaluation8;

   if(dueToRevaluation9Test !== dueToRevaluation9ShouldBe){
      flagC=1;
      // let a="add red class"
      // dueToRevaluation9 make red
      allRowsObject.customItemCodes[9].dueToRevaluationClass="textBox_back_color_red";
   } else {
      // let b= "add white class"
      // dueToRevaluation9 make while
      allRowsObject.customItemCodes[9].dueToRevaluationClass="textBox_back_color_white";
   }
   return valueInsertedA3(allRowsObject);
}

const valueInsertedA3=(allRowsObject)=>{
   const actualAdditionsRow=allRowsObject.actualAdditionsObject;
   const actualAdditions1 = actualAdditionsRow[1];
   const actualAdditions2 = actualAdditionsRow[2];
   const actualAdditions3 = actualAdditionsRow[3];
   const actualAdditions4 = actualAdditionsRow[4];
   const actualAdditions5 = actualAdditionsRow[5];
   const actualAdditions6 = actualAdditionsRow[6];
   const actualAdditions7test = actualAdditionsRow[7];

   const actualAdditions1to6 = (actualAdditions1 + actualAdditions2 + actualAdditions3 + actualAdditions4 + actualAdditions5 + actualAdditions6);


   if(actualAdditions7test !== actualAdditions1to6){
      flagC=1;
      // let a="add red class"
      // actualAdditions7 make red
      allRowsObject.customItemCodes[7].actualAdditionsClass="textBox_back_color_red";
   } else {
      // let b= "add white class"
      // actualAdditions7 make while
      allRowsObject.customItemCodes[7].actualAdditionsClass="textBox_back_color_white";
   }
   return valueInsertedB3(allRowsObject);
}
;
const valueInsertedB3=(allRowsObject)=>{

   

   const actualAdditionsRow=allRowsObject.actualAdditionsObject;
   const actualAdditions0 = actualAdditionsRow[0];
   const actualAdditions8 = actualAdditionsRow[8];
   const actualAdditions9test = actualAdditionsRow[9];

   const actualAdditions1 = actualAdditionsRow[1];
   const actualAdditions2 = actualAdditionsRow[2];
   const actualAdditions3 = actualAdditionsRow[3];
   const actualAdditions4 = actualAdditionsRow[4];
   const actualAdditions5 = actualAdditionsRow[5];
   const actualAdditions6 = actualAdditionsRow[6];
   
   const cval = (actualAdditions1 + actualAdditions2 + actualAdditions3 + actualAdditions4 + actualAdditions5 + actualAdditions6);

   const actualAdditions0plus8 = (actualAdditions0 + cval +  actualAdditions8)
   
   if(actualAdditions9test !== actualAdditions0plus8){
      flagC=1;
      // let a="add red class"
      // actualAdditions9 make red
      allRowsObject.customItemCodes[9].actualAdditionsClass="textBox_back_color_red";
   } else {
      // let b= "add white class"
      // actualAdditions9 make while
      allRowsObject.customItemCodes[9].actualAdditionsClass="textBox_back_color_white";
   }
   return valueInsertedA4(allRowsObject);
}

const valueInsertedA4=(allRowsObject)=>{
   const deductionAdjDuringYearRow=allRowsObject.deductionAdjDuringYearObject;

   const deductionAdjDuringYear1 = deductionAdjDuringYearRow[1];
   const deductionAdjDuringYear2 = deductionAdjDuringYearRow[2];
   const deductionAdjDuringYear3 = deductionAdjDuringYearRow[3];
   const deductionAdjDuringYear4 = deductionAdjDuringYearRow[4];
   const deductionAdjDuringYear5 = deductionAdjDuringYearRow[5];
   const deductionAdjDuringYear6 = deductionAdjDuringYearRow[6];
   const deductionAdjDuringYear7test = deductionAdjDuringYearRow[7];
   
   const deductionAdjDuringYear1to6 = (deductionAdjDuringYear1 + deductionAdjDuringYear2 + deductionAdjDuringYear3 + deductionAdjDuringYear4 + deductionAdjDuringYear5 + deductionAdjDuringYear6);

   if(deductionAdjDuringYear7test !== deductionAdjDuringYear1to6){
      flagC=1;
      // let a="add red class"
      // duductionAdjDuringYear7 make red
      allRowsObject.customItemCodes[7].deductionAdjDuringYearClass="textBox_back_color_red";
   } else {
      // let b= "add white class"
      // duductionAdjDuringYear7 make while
      allRowsObject.customItemCodes[7].deductionAdjDuringYearClass="textBox_back_color_white";
   }
   return valueInsertedB4(allRowsObject);
}

const valueInsertedB4=(allRowsObject)=>{
   const deductionAdjDuringYearRow=allRowsObject.deductionAdjDuringYearObject;

   const deductionAdjDuringYear0 = deductionAdjDuringYearRow[0];
   const deductionAdjDuringYear7 = deductionAdjDuringYearRow[7];
   const deductionAdjDuringYear8 = deductionAdjDuringYearRow[8];
   const deductionAdjDuringYear9test = deductionAdjDuringYearRow[9];
   
   // Corrected: Row 10 = Row 1 + Row 8 + Row 9 (index 0 + 7 + 8)
   const deductionAdjDuringYear10ShouldBe = deductionAdjDuringYear0 + deductionAdjDuringYear7 + deductionAdjDuringYear8;

   if(deductionAdjDuringYear9test !== deductionAdjDuringYear10ShouldBe){
      flagC=1;
      // let a="add red class"
      // duductionAdjDuringYear9 make red
      allRowsObject.customItemCodes[9].deductionAdjDuringYearClass="textBox_back_color_red";
   } else {
      // let b= "add white class"
      // duductionAdjDuringYear9 make while
      allRowsObject.customItemCodes[9].deductionAdjDuringYearClass="textBox_back_color_white";
   }
   return valueInsertedA5(allRowsObject);
}

const valueInsertedA5=(allRowsObject)=>{
   const uptoYearBeginningRow=allRowsObject.uptoYearBeginningObject;

   const uptoYearBeginning1 = uptoYearBeginningRow[1];
   const uptoYearBeginning2 = uptoYearBeginningRow[2];
   const uptoYearBeginning3 = uptoYearBeginningRow[3];
   const uptoYearBeginning4 = uptoYearBeginningRow[4];
   const uptoYearBeginning5 = uptoYearBeginningRow[5];
   const uptoYearBeginning6 = uptoYearBeginningRow[6];
   const uptoYearBeginning7test = uptoYearBeginningRow[7];

   const uptoYearBeginning1to6 = (uptoYearBeginning1 + uptoYearBeginning2 + uptoYearBeginning3 + uptoYearBeginning4 + uptoYearBeginning5 + uptoYearBeginning6);

   if(uptoYearBeginning7test !== uptoYearBeginning1to6){
      flagC=1;
      // let a="add red class"
      // uptoYearBeginning7 make red
      allRowsObject.customItemCodes[7].uptoYearBeginningClass="textBox_back_color_red";
   } else {
      // let b= "add white class"
      // uptoYearBeginning7 make while
      allRowsObject.customItemCodes[7].uptoYearBeginningClass="textBox_back_color_white";
   }
   return valueInsertedB5(allRowsObject);
}

const valueInsertedB5=(allRowsObject)=>{
   const uptoYearBeginningRow=allRowsObject.uptoYearBeginningObject;

   const uptoYearBeginning0 = uptoYearBeginningRow[0];
   const uptoYearBeginning8 = uptoYearBeginningRow[8];
   const uptoYearBeginning9test = uptoYearBeginningRow[9];

   const uptoYearBeginning1 = uptoYearBeginningRow[1];
   const uptoYearBeginning2 = uptoYearBeginningRow[2];
   const uptoYearBeginning3 = uptoYearBeginningRow[3];
   const uptoYearBeginning4 = uptoYearBeginningRow[4];
   const uptoYearBeginning5 = uptoYearBeginningRow[5];
   const uptoYearBeginning6 = uptoYearBeginningRow[6];

   const fval = (uptoYearBeginning1 + uptoYearBeginning2 + uptoYearBeginning3 + uptoYearBeginning4 + uptoYearBeginning5 + uptoYearBeginning6);
   
   const uptoYearBeginning0to8 = (uptoYearBeginning0 + fval +  uptoYearBeginning8);

   if(uptoYearBeginning9test !== uptoYearBeginning0to8){
      flagC=1;
      // let a="add red class"
      // uptoYearBeginning9 make red
      allRowsObject.customItemCodes[9].uptoYearBeginningClass="textBox_back_color_red";
   } else {
      // let b= "add white class"
      // uptoYearBeginning9 make while
      allRowsObject.customItemCodes[9].uptoYearBeginningClass="textBox_back_color_white";
   }
   return valueInsertedA6(allRowsObject);
}

const valueInsertedA6=(allRowsObject)=>{
   const providedDuringYearRow=allRowsObject.providedDuringYearObject;

   const providedDuringYear1 = providedDuringYearRow[1];
   const providedDuringYear2 = providedDuringYearRow[2];
   const providedDuringYear3 = providedDuringYearRow[3];
   const providedDuringYear4 = providedDuringYearRow[4];
   const providedDuringYear5 = providedDuringYearRow[5];
   const providedDuringYear6 = providedDuringYearRow[6];
   const providedDuringYear7test = providedDuringYearRow[7];

   const providedDuringYear1to6 = (providedDuringYear1 + providedDuringYear2 + providedDuringYear3 + providedDuringYear4 + providedDuringYear5 + providedDuringYear6);

   if(providedDuringYear7test !== providedDuringYear1to6){
      flagC=1;
      // let a="add red class"
      // providedDuringYear7 make red
      allRowsObject.customItemCodes[7].providedDuringYearClass="textBox_back_color_red";
   } else {
      // let b= "add white class"
      // providedDuringYear7 make while
      allRowsObject.customItemCodes[7].providedDuringYearClass="textBox_back_color_white";
   }
   return valueInsertedB6(allRowsObject);
}

const valueInsertedB6=(allRowsObject)=>{
   const providedDuringYearRow=allRowsObject.providedDuringYearObject;

   const providedDuringYear0 = providedDuringYearRow[0];
   const providedDuringYear8 = providedDuringYearRow[8];
   const providedDuringYear9test = providedDuringYearRow[9];

   const providedDuringYear1 = providedDuringYearRow[1];
   const providedDuringYear2 = providedDuringYearRow[2];
   const providedDuringYear3 = providedDuringYearRow[3];
   const providedDuringYear4 = providedDuringYearRow[4];
   const providedDuringYear5 = providedDuringYearRow[5];
   const providedDuringYear6 = providedDuringYearRow[6];

   const gval = (providedDuringYear1 + providedDuringYear2 + providedDuringYear3 + providedDuringYear4 + providedDuringYear5 + providedDuringYear6);
   
   const providedDuringYear0to8 = (providedDuringYear0 + gval + providedDuringYear8);

   if(providedDuringYear9test !== providedDuringYear0to8){
      flagC=1;
      // let a="add red class"
      // providedDuringYear9 make red
      allRowsObject.customItemCodes[9].providedDuringYearClass="textBox_back_color_red";
   } else {
      // let b= "add white class"
      // providedDuringYear9 make while
      allRowsObject.customItemCodes[9].providedDuringYearClass="textBox_back_color_white";
   }
   return valueInsertedA7(allRowsObject);
}

const valueInsertedA7=(allRowsObject)=>{
   const adjForSoldDiscardedDuringYearRow=allRowsObject.adjForSoldDiscardedDuringYearObject;

   const adjForSoldDiscardedDuringYear1 = adjForSoldDiscardedDuringYearRow[1];
   const adjForSoldDiscardedDuringYear2 = adjForSoldDiscardedDuringYearRow[2];
   const adjForSoldDiscardedDuringYear3 = adjForSoldDiscardedDuringYearRow[3];
   const adjForSoldDiscardedDuringYear4 = adjForSoldDiscardedDuringYearRow[4];
   const adjForSoldDiscardedDuringYear5 = adjForSoldDiscardedDuringYearRow[5];
   const adjForSoldDiscardedDuringYear6 = adjForSoldDiscardedDuringYearRow[6];
   const adjForSoldDiscardedDuringYear7test = adjForSoldDiscardedDuringYearRow[7];

   const adjForSoldDiscardedDuringYear1to6 = (adjForSoldDiscardedDuringYear1 + adjForSoldDiscardedDuringYear2 + adjForSoldDiscardedDuringYear3 + adjForSoldDiscardedDuringYear4 + adjForSoldDiscardedDuringYear5 + adjForSoldDiscardedDuringYear6);


   if(adjForSoldDiscardedDuringYear7test !== adjForSoldDiscardedDuringYear1to6){
      flagC=1;
      // let a="add red class"
      // adjForSoldDiscardedDuringYear7 make red
      allRowsObject.customItemCodes[7].adjForSoldDiscardedDuringYearClass="textBox_back_color_red";
   } else {
      // let b= "add white class"
      // adjForSoldDiscardedDuringYear7 make while
      allRowsObject.customItemCodes[7].adjForSoldDiscardedDuringYearClass="textBox_back_color_white";
   }
   handleValidationAlert(allRowsObject.customItemCodes);

   if (statusAlertC === 1) {
     
      allValidactionAlertBlockC = allValidactionAlertBlockC+" \nFor change any Values Click OK."
         let clicked = window.confirm(allValidactionAlertBlockC); 
      
         allValidactionAlertBlockC="";
         statusAlertC = 0;
         if(clicked){
            //valifla = "notnull";
            return false;
         }

   }

   if(flagC===1)
   { 
      //handleValidationAlert(allRowsObject.customItemCodes);
      alert('Total does not match. Please check highlighted fields');
      flagC=0;
      return false;
   }
return true;







}







  return (
    <div className="card-body">
    {/* <ToastContainer/> */}
         <h4 className="page_heading border-bottom-0">
            <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? asiTitle.hi.BLOCK_C_TITLE : asiTitle.en.BLOCK_C_TITLE }} />
          </h4>
          <div className="row">
          <div className="col-12 pb-3">
                     <h6 className="fw-semibold">
                     {storedLanguage === 'hi' ? asiTitle.hi.DSL_NO : asiTitle.en.DSL_NO}: <span className="fw-normal me-5">{staticDslNo}</span> 
                     {storedLanguage === 'hi' ? asiTitle.hi.SERVEY_YEAR : asiTitle.en.SERVEY_YEAR}: <span className="fw-normal">{yearRange}</span>
                    </h6>
                  </div>
               <div className="col-12">
                  <div className="asi_block_table">
                     <table cellPadding="0" cellSpacing="0" id="" className="table table-bordered">
                        <thead>
                           <tr>
                              <th className="text-center" rowSpan="3">{storedLanguage === 'hi' ? asiTitle.hi.SL_NO : asiTitle.en.SL_NO}</th>
                              <th className="text-center" rowSpan="3">{storedLanguage === 'hi' ? asiTitle.hi.TYPE_OF_ASSETS : asiTitle.en.TYPE_OF_ASSETS}</th>
                              <th className="text-center" colSpan="5">{storedLanguage === 'hi' ? asiTitle.hi.GROSS_VALUE : asiTitle.en.GROSS_VALUE}</th>
                              <th className="text-center" colSpan="4">{storedLanguage === 'hi' ? asiTitle.hi.DESCRIPTION : asiTitle.en.DESCRIPTION}</th>
                              <th className="text-center" colSpan="2">{storedLanguage === 'hi' ? asiTitle.hi.NET_VALUE : asiTitle.en.NET_VALUE}</th>
                           </tr>
                           <tr>
                              <th className="text-center" rowSpan="2">{storedLanguage === 'hi' ? asiTitle.hi.OPENING_AS_ON : asiTitle.en.OPENING_AS_ON}</th>
                              <th className="text-center" colSpan="2">{storedLanguage === 'hi' ? asiTitle.hi.ADDITIONAL_DURING_THE_YEAR : asiTitle.en.ADDITIONAL_DURING_THE_YEAR}</th>
                              <th className="text-center" rowSpan="2"><div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? asiTitle.hi.DEDUCTION_DURING_YEAR : asiTitle.en.DEDUCTION_DURING_YEAR }} /></th>
                              <th className="text-center" rowSpan="2"><div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? asiTitle.hi.CLOSING_AS_ON : asiTitle.en.CLOSING_AS_ON }} /></th>
                              <th className="text-center" rowSpan="2">{storedLanguage === 'hi' ? asiTitle.hi.UP_TO_YEAR_BEGINING : asiTitle.en.UP_TO_YEAR_BEGINING}</th>
                              <th className="text-center" rowSpan="2"><div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? asiTitle.hi.PROVIDE_DURING_YEAR : asiTitle.en.PROVIDE_DURING_YEAR }} /></th>
                              <th className="text-center" rowSpan="2"><div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? asiTitle.hi.SOLD_DISCARD_DURING_YEAR : asiTitle.en.SOLD_DISCARD_DURING_YEAR }} /></th>
                              <th className="text-center" rowSpan="2"><div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? asiTitle.hi.UP_TO_YEAR_END : asiTitle.en.UP_TO_YEAR_END }} /></th>
                              <th className="text-center" rowSpan="2"><div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? asiTitle.hi.OPENING_AS_ONS : asiTitle.en.OPENING_AS_ONS }} /></th>
                              <th className="text-center" rowSpan="2"><div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? asiTitle.hi.CLOSING_AS_ONS : asiTitle.en.CLOSING_AS_ONS }} /></th>
                           </tr>
                           <tr>
                              <th className="text-center">{storedLanguage === 'hi' ? asiTitle.hi.DUE_TO_REVALUATION : asiTitle.en.DUE_TO_REVALUATION}</th>
                              <th className="text-center">{storedLanguage === 'hi' ? asiTitle.hi.ACTUAL_ADDITION : asiTitle.en.ACTUAL_ADDITION}</th>
                           </tr>
                           <tr>
                              <th className="text-center">1</th>
                              <th className="text-center">2</th>
                              <th className="text-center">3</th>
                              <th className="text-center">4</th>
                              <th className="text-center">5</th>
                              <th className="text-center">6</th>
                              <th className="text-center">7</th>
                              <th className="text-center">8</th>
                              <th className="text-center">9</th>
                              <th className="text-center">10</th>
                              <th className="text-center">11</th>
                              <th className="text-center">12</th>
                              <th className="text-center">13</th>
                           </tr>
                        </thead>
                        <tbody>

                          {/* Using static data - blockCData.length>0 && blockCData.map((item,i)=>{ */}
                          {staticBlockCData.map((item,i)=>{
                              // Convert assetCode to string for consistent key access
                              const assetCodeKey = String(item.assetCode);
                              // Get data for this assetCode, or use empty object if not available
                              const currentItemData = itemData[assetCodeKey] || {};
                              return (  
                              <tr key={i}>
                              <td>{i + 1}
                                
                              </td>
                              <td key={i} className={i === 0 || i === 2 || i === 6 ? "bold-text" : ""}>{item.ItemName}</td>
                              <td className={currentItemData.openingAsOnClass || 'textBox_back_color_white'}>
                                 <input 
                                 type="text" 
                                 className="form-control"
                                 maxLength="18"
                                 id={`openingAsOn${i}`}
                                 name={`openingAsOn${i}`}
                                 value={currentItemData.openingAsOn ?? ""}
                                 onChange={e => handleOnChange(item.assetCode, 'openingAsOn', e.target.value)}
                                  />
                              </td>
                              <td className={currentItemData.dueToRevaluationClass || 'textBox_back_color_white'}>
                                 <input 
                                 type="text" 
                                 className="form-control"
                                 maxLength="18"
                                 id={`dueToRevaluation${i}`}
                                 name={`dueToRevaluation${i}`}
                                 value={currentItemData.dueToRevaluation ?? ""}
                                 onChange={e => handleOnChange(item.assetCode, 'dueToRevaluation', e.target.value)}
                                 />
                              </td>
                              <td className={currentItemData.actualAdditionsClass || 'textBox_back_color_white'}> 
                                 <input 
                                  type="text" 
                                  className="form-control"
                                  maxLength="18"
                                  id={`actualAdditions${i}`}
                                  name={`actualAdditions${i}`}
                                  value={currentItemData.actualAdditions ?? ""}
                                  onChange={e => handleOnChange(item.assetCode, 'actualAdditions', e.target.value)}
                                  />
                              </td>
                              <td className={currentItemData.deductionAdjDuringYearClass || 'textBox_back_color_white'}>
                                 <input 
                                 type="text" 
                                 className="form-control"
                                 maxLength="18"
                                 id={`deductionAdjDuringYear${i}`}
                                 name={`deductionAdjDuringYear${i}`}
                                 value={currentItemData.deductionAdjDuringYear ?? ""}
                                 onChange={e => handleOnChange(item.assetCode, 'deductionAdjDuringYear', e.target.value)}
                                 />
                              </td>
                              <td className={currentItemData.closingAsOn3456Class || 'textBox_back_color_white'}>
                                 <input 
                                 type="text" 
                                 className="form-control"
                                 maxLength="18"
                                 id={`closingAsOn3456${i}`}
                                 name={`closingAsOn3456${i}`}
                                 value={currentItemData.closingAsOn3456 ?? ""}
                                 onChange={e => handleOnChange(item.assetCode, 'closingAsOn3456', e.target.value)}
                                 />
                              </td>
                              <td className={currentItemData.uptoYearBeginningClass || 'textBox_back_color_white'}>
                              <input 
                                 type="text" 
                                 className="form-control"
                                  maxLength="18"
                                 id={`uptoYearBeginning${i}`}
                                 name={`uptoYearBeginning${i}`}
                                 value={currentItemData.uptoYearBeginning ?? ""}
                                 onChange={e => handleOnChange(item.assetCode, 'uptoYearBeginning', e.target.value)}
                                 />
                              </td>
                              <td className={currentItemData.providedDuringYearClass || 'textBox_back_color_white'}>
                              <input 
                                 type="text" 
                                 className="form-control"
                                 maxLength="18"
                                 id={`providedDuringYear${i}`}
                                 name={`providedDuringYear${i}`}
                                 value={currentItemData.providedDuringYear ?? ""}
                                 onChange={e => handleOnChange(item.assetCode, 'providedDuringYear', e.target.value)}
                                 />
                              </td>
                              <td className={currentItemData.adjForSoldDiscardedDuringYearClass || 'textBox_back_color_white'}>
                              <input 
                                 type="text" 
                                 className="form-control"
                                 maxLength="18"
                                 id={`adjForSoldDiscardedDuringYear${i}`}
                                 name={`adjForSoldDiscardedDuringYear${i}`}
                                 value={currentItemData.adjForSoldDiscardedDuringYear ?? ""}
                                 onChange={e => handleOnChange(item.assetCode, 'adjForSoldDiscardedDuringYear', e.target.value)}
                                 />
                              </td>
                              <td className={currentItemData.uptoYearEndClass || 'textBox_back_color_white'}>
                              <input 
                                 type="text" 
                                 className="form-control"
                                 maxLength="18"
                                 id={`uptoYearEnd${i}`}
                                 name={`uptoYearEnd${i}`}
                                 value={currentItemData.uptoYearEnd ?? ""}
                                 onChange={e => handleOnChange(item.assetCode, 'uptoYearEnd', e.target.value)}
                                 />
                              </td>
                              <td className={currentItemData.openingAsOn38Class || 'textBox_back_color_white'}> 
                              <input 
                                 type="text" 
                                 className="form-control"
                                 maxLength="18"
                                 id={`openingAsOn38${i}`}
                                 name={`openingAsOn38${i}`}
                                 value={currentItemData.openingAsOn38 ?? ""}
                                 onChange={e => handleOnChange(item.assetCode, 'openingAsOn38', e.target.value)}
                                 />
                              </td>
                              <td className={currentItemData.closingAsOn711Class || 'textBox_back_color_white'}>
                              <input 
                                 type="text" 
                                 className="form-control"
                                 maxLength="18"
                                 id={`closingAsOn711${i}`}
                                 name={`closingAsOn711${i}`}
                                 value={currentItemData.closingAsOn711 ?? ""}
                                 onChange={e => handleOnChange(item.assetCode, 'closingAsOn711', e.target.value)}
                                 />
                              </td>
                               </tr>
                              )
                          })}
                          {/* End of static data mapping */}
                           
                          
                        </tbody>
                     </table>
                  </div>
               </div>
               
            </div>

            <div className="row">
                <div className="col-12">
                  <hr/>
                </div>
            
                <div className="col-lg-8 text-center text-lg-start mb-3 mb-lg-0">
                      <button 
                      type="submit" 
                      className="btn btn_orange me-1"
                      onClick={()=>{ window.print()}}
                      >Print 
                      <i className="fa fa-print ms-1"></i>
                      </button>

                      <button 
                      type="button" 
                      className="btn btn_orange me-1"
                      onClick={(e)=>{handleSaveData("SAVE")}}
                      disabled={buttonStatus}>
                      Save
                     </button>

                      <button 
                      type="reset" 
                      className="btn btn_orange me-1"
                      onClick={handleReset}
                      >
                      Reset
                     </button>

                      <button 
                      type="button" 
                      className="btn btn_orange"
                      onClick={(e)=>( navigate("/dashboard"))}
                      >
                      Cancel
                    </button>

                </div>
              
                <div className="col-lg-4 text-center text-lg-end">
                  <button 
                  type="button" 
                  className="btn btn_orange mx-1"
                  onClick={handlePrevious}
                  >
                  <i className="fa fa-angle-left me-1"></i> 
                  Previous
                 </button>

                  <button 
                  type="button" 
                  className="btn btn_orange mx-1"
                  onClick={handleNext}
                  >
                  Next 
                  <i className="fa fa-angle-right ms-1"></i>
                </button>

                </div>
                        
            </div>

   </div>

  )
}
